import React, { useState, useEffect } from "react";
import { Grid, IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { ArrowBack, Visibility } from "@mui/icons-material";
import MDButton from "components/MDButton";
import CommentSection from "./commentSection";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { API_URL } from "config";
import { SOCKET_URL } from "config";

const PreviewDocument = ({ document, onClose }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showComments, setShowComments] = useState(false);

  const toggleComments = () => setShowComments(!showComments);
  const closeComments = () => setShowComments(false);

  useEffect(() => {
    const fetchPdfUrl = async () => {
      try {
        const fileUrl = `${SOCKET_URL}/${document.path}`;
        const response = await fetch(
          `${API_URL}/files/convert-to-pdf?file=${encodeURIComponent(fileUrl)}`
        );

        const data = await response.json();
        if (data.pdfUrl) {
          setPdfUrl(data.pdfUrl);
          console.log("PDF URL:", data.pdfUrl);
        } else {
          setError("Failed to load PDF.");
        }
      } catch (err) {
        setError("Error fetching PDF.");
      } finally {
        setLoading(false);
      }
    };
    fetchPdfUrl();
  }, [document.path]);

  return (
    <MDBox mb={2}>
      <MDBox display="flex" alignItems="center" mb={1}>
        <IconButton onClick={onClose}>
          <ArrowBack />
        </IconButton>
        <MDTypography variant="h5" ml={1}>
          Go Back
        </MDTypography>
      </MDBox>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={showComments ? 8 : 10}
          lg={showComments ? 8 : 10}
        >
          <MDBox height={450} borderRadius="lg" shadow="lg">
            {loading ? (
              <MDTypography>Loading PDF...</MDTypography>
            ) : error ? (
              <MDTypography color="error">{error}</MDTypography>
            ) : (
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                <Viewer fileUrl={pdfUrl} />
              </Worker>
            )}
          </MDBox>
        </Grid>
        <Grid item xs={12} md={showComments ? 4 : 2} lg={showComments ? 4 : 2}>
          {!showComments ? (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <MDButton
                variant="contained"
                color="dark"
                onClick={toggleComments}
                startIcon={<Visibility />}
              >
                Show Comments
              </MDButton>
            </MDBox>
          ) : (
            <CommentSection closeComments={closeComments} document={document} />
          )}
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default PreviewDocument;
